// Layout shell for /admin/ops/*. Adds a sub-nav with the 3 primary
// surfaces (dashboard, findings inbox, runs) and reuses the parent
// _app layout for the chrome.
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/ops")({
  component: OpsLayout,
});

function OpsLayout() {
  return (
    <div className="space-y-6">
      <div className="flex items-baseline justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl tracking-tight">Operations</h1>
          <p className="text-sm text-muted">
            Findings inbox and run history. Phase 2 covers balance flow integrity; Phase 3 covers matching-engine integrity. Drill into a finding for cross-service context.
          </p>
        </div>
        <a
          className="text-sm text-muted hover:text-fg"
          href="https://sit-sm-airflow.devcula.com/"
          target="_blank"
          rel="noreferrer"
        >
          ↗ Airflow
        </a>
      </div>
      <nav className="flex gap-4 border-b border-border text-sm">
        <SubNavLink to="/ops" exact>Dashboard</SubNavLink>
        <SubNavLink to="/ops/findings">Findings</SubNavLink>
        <SubNavLink to="/ops/runs">Runs</SubNavLink>
        <SubNavLink to="/ops/brokers">Brokers</SubNavLink>
        <SubNavLink to="/ops/provider">Provider</SubNavLink>
      </nav>
      <Outlet />
    </div>
  );
}

function SubNavLink({ to, exact, children }: { to: string; exact?: boolean; children: React.ReactNode }) {
  return (
    <Link
      to={to}
      activeOptions={{ exact: !!exact }}
      activeProps={{ className: "border-b-2 border-fg text-fg pb-2" }}
      inactiveProps={{ className: "border-b-2 border-transparent text-muted hover:text-fg pb-2" }}
    >
      {children}
    </Link>
  );
}
